/**
 *  EDAP events
 */

const actionlocation = 'scratchpad-module';

export const SCRATCHPAD_RECENTACTIVITY_VIEWALL_CLICK = {
  name: 'recentactivity.viewall.click',
  data: {
    actionlocation
  }
};

export const SCRATCHPAD_RECENTACTIVITY_CONTINUE_CLICK = ({ lbsUuid }) => ({
  name: 'recentactivity.continue.click',
  data: {
    actionlocation,
    eventlbsuuid: lbsUuid
  }
});

export const SCRATCHPAD_RECENTACTIVITY_VIEW = ({ searchTerm }) => ({
  name: 'recentactivity.view',
  data: {
    actionlocation,
    eventsearchterm: searchTerm
  }
});

export const SCRATCHPAD_CLICK_PREV = {
  name: 'nav.previous.click',
  data: {
    actionlocation
  }
};

export const SCRATCHPAD_CLICK_NEXT = {
  name: 'nav.next.click',
  data: {
    actionlocation
  }
};

export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation
};
